module.exports = __webpack_public_path__ + "img/矩形 687@2x.f503f122.png";